<template>
  <div class="card block">
    <div class="block__actions p-3 px-md-4">
      <div class="block__actions-title">
        <i :class="`fas fa-${block.specification.icon}`" aria-hidden="true"></i>

        {{ block.specification.label }}
      </div>

      <div class="block__actions-buttons">
        <button
          type="button"
          title="In- en uitklappen"
          :class="`block__actions-button js-action-button is-collapse ${isCollapsed ? 'is-collapsed' : ''}`"
          @click="$emit('collapse', block.id)"
        >
          <i class="fas fa-chevron-up" aria-hidden="true"></i>
          <i class="fas fa-chevron-down" aria-hidden="true"></i>
          <span class="sr-only">Inklappen</span>
        </button>

        <button type="button" title="Kopiëren" class="block__actions-button js-action-button is-delete" @click="$emit('copy', block.id)">
          <i class="fas fa-copy" aria-hidden="true"></i>
          <span class="sr-only">Kopi&euml;ren</span>
        </button>

        <button type="button" title="Verwijderen" class="block__actions-button js-action-button is-delete" @click="$emit('remove', block.id)">
          <i class="fas fa-times" aria-hidden="true"></i>
          <span class="sr-only">Verwijderen</span>
        </button>

        <button type="button" title="Plaats 1 blok omhoog" class="block__actions-button js-action-button is-up" @click="$emit('move', block.id, 'up')">
          <i class="fas fa-arrow-up" aria-hidden="true"></i>
          <span class="sr-only">Omhoog</span>
        </button>

        <button type="button" title="Plaats 1 blok omlaag" class="block__actions-button js-action-button is-down" @click="$emit('move', block.id, 'down')">
          <i class="fas fa-arrow-down" aria-hidden="true"></i>
          <span class="sr-only">Omlaag</span>
        </button>
      </div>
    </div>

    <div class="block__content p-3 p-md-4" v-if="!isCollapsed">
      <block-fields :block="block" @field-update="handleFieldUpdate" />
    </div>
  </div>
</template>

<script>
  import BlockFields from './BlockFields';

  export default {
    props: ['block', 'onMove', 'onRemove', 'isCollapsed'],

    components: {
      BlockFields,
    },

    methods: {
      handleFieldUpdate(...args) {
        this.$emit('field-update', ...args);
      },
    },
  };
</script>
